exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img-wrap[data-v-5a6bcd88] {\n  line-height: 0;\n}\nimg[data-v-5a6bcd88] {\n  display: inline-block;\n  position: relative;\n  line-height: 0;\n  width: 100%;\n  height: 100%;\n  min-width: 100%;\n  max-width: 100%;\n  min-height: 100%;\n  max-height: 100%;\n}\n", ""]);

// exports
